import { type MCPServerInfo } from '../../types';

const ClickupServer: MCPServerInfo = {
  serverId: 'CLICKUP',
  name: 'ClickUp',
  slug: 'clickup',
  description:
    'ClickUp MCP Server for task management and project collaboration',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.clickup.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ClickupServer;
